import React from 'react';
import { Empty, Spin, Alert } from 'antd';
import './ItemDetailsCard.less';

export default function ItemDetailsCard({ data, loading, error, hasSearched }) {
  if (loading) {
    return (
      <div className="item-details-card">
        <Spin tip="Loading..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="item-details-card">
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  if (!hasSearched || !data) {
    return (
      <div className="item-details-card">
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No data available. Please perform a search above."
        />
      </div>
    );
  }

  const detailBoxes = [
    // { label: 'ITEM/SUB', value: data.itemNumber, isHighlight: true },
    { label: 'ITEM', value: data.itemNumber, isHighlight: true },
    // { label: 'PACK/SIZE', value: data.pack?.trim() || '-' },
    { label: 'PACK/SIZE', value: (data.pack?.trim() && data.size?.trim()) ? `${data.pack.trim()}/${data.size.trim()}` : '-'},
    { label: 'BRAND', value: data.brand },
    { label: 'ITEM DESCRIPTION', value: data.itemDescription },
    { label: 'MQ STATUS', value: data.itemStatus },
    // { label: 'LT', value: '' },
    { label: 'PROP', value: data.proprietaryItem?.trim() || '-' },
    { label: 'STOCK TYPE', value: data.stockType },
    { label: 'CW', value: data.itemCatchWghtInd },
    { label: 'DMS', value: data.demandStatus?.trim() || '-' },
    // { label: 'NXT REC', value: data.qtyOnHand || '0' },
   // { label: 'QOH', value: `${data.qtyOnHand - data.qtyOnHandSplits}` || '-' },
   // { label: 'QOO', value: '-' },
    // { label: 'ALC', value: '' || '0' },
    // { label: 'QHLD', value: '-' },
    //{ label: 'QOOS', value: `${data.qtyOnHandOutCases - data.qtyOnHandOutSplits}` || '-' },
    //  { label: 'QOH', value: `${data.qtyOnHand ?? 0} - ${data.qtyOnHandSplits ?? 0}` },
    //  { label: 'QOOS', value: `${data.qtyOnHandOutCases ?? 0} - ${data.qtyOnHandOutSplits ?? 0}` },

    { label: 'QOH', value: data.qtyOnHand || '-' },
    { label: 'QOSS', value: data.quantityOnSplits || '-' },
  
    // { label: 'ASOH', value: '' || '0' },
  ];

  return (
    <div className="item-details-card">
      <div className="details-grid">
        {detailBoxes.map((box, index) => (
          <div key={index} className="detail-box">
            <div className="detail-label">{box.label}</div>
            <div className={`detail-value ${box.isHighlight ? 'highlight-blue' : ''}`}>
              {box.value || '-'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


